import { EmployeeGroupOutput } from './employee-group-output.model';


export class EmployeeGroupSelectByIdOutput implements IEmployeeGroupSelectByIdOutput {
    status!: number;
    message!: string;
    data!: EmployeeGroupOutput;

    constructor(data?: IEmployeeGroupSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? EmployeeGroupOutput.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployeeGroupSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeGroupSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IEmployeeGroupSelectByIdOutput {
    status: number;
    message: string;
    data: EmployeeGroupOutput;
}

